"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var frame_1 = require("./frame");
// Define constants for bytes used throughout the code.
exports.BYTES = {
    // LINEFEED byte (octet 10)
    LF: '\x0A',
    // NULL byte (octet 0)
    NULL: '\x00'
};
// utility function to trim any whitespace before and after a string
exports.trim = function (str) { return str.replace(/^\s+|\s+$/g, ''); };
// from https://coolaj86.com/articles/unicode-string-to-a-utf-8-typed-array-buffer-in-javascript/
function unicodeStringToTypedArray(s) {
    var escstr = encodeURIComponent(s);
    var binstr = escstr.replace(/%([0-9A-F]{2})/g, function (match, p1) { return String.fromCharCode(('0x' + p1)); });
    var arr = Array.prototype.map.call(binstr, function (c) { return c.charCodeAt(0); });
    return new Uint8Array(arr);
}
exports.unicodeStringToTypedArray = unicodeStringToTypedArray;
// from https://coolaj86.com/articles/unicode-string-to-a-utf-8-typed-array-buffer-in-javascript/
function typedArrayToUnicodeString(ua) {
    var binstr = String.fromCharCode.apply(String, ua);
    var escstr = binstr.replace(/(.)/g, function (m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = '0' + code;
        }
        return '%' + code;
    });
    return decodeURIComponent(escstr);
}
exports.typedArrayToUnicodeString = typedArrayToUnicodeString;
// Compute the size of a UTF-8 string by counting its number of bytes
// (and not the number of characters composing the string)
function sizeOfUTF8(s) {
    if (!s)
        return 0;
    return encodeURIComponent(s).match(/%..|./g).length;
}
exports.sizeOfUTF8 = sizeOfUTF8;
exports.parseData = function (data, partialData, hearbeatMsg) {
    if (data instanceof ArrayBuffer) {
        data = typedArrayToUnicodeString(new Uint8Array(data));
    }
    // heartbeat
    if (data === hearbeatMsg) {
        logger.debug("<<< PONG");
        return;
    }
    logger.debug("<<< " + data);
    // Handle STOMP frames received from the server
    // The unmarshall function returns the frames parsed and any remaining
    // data from partial frames are buffered.
    var unmarshalledData = frame_1.default.unmarshall(partialData + data);
    return unmarshalledData;
};
var Log = /** @class */ (function () {
    function Log() {
        var _this = this;
        this.hasDebug = false;
        this.setDebug = function (_hasDebug) {
            _this.hasDebug = _hasDebug;
        };
        this.debug = function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (_this.hasDebug)
                console.log.apply(console, [message].concat(args));
        };
    }
    return Log;
}());
exports.Log = Log;
var logger = new Log();
exports.logger = logger;
